import { useParams, useFm } from '@web3/base-hooks';
import { ArrowchevronRightIcon } from '@bfe/moly-icons';
import cls from 'classnames';

import styles from './index.module.scss';

interface Props {
  subPageName: string;
  className?: string;
  onClickHome?: () => void;
}

export const BreadCrumbs = (props: Props) => {
  const { subPageName, className, onClickHome } = props;
  const { locale } = useParams();
  const fm = useFm();

  const handleHomePage = () => {
    onClickHome?.();
    window.open(`${window.location.origin}/${locale}/web3/aidol2025`, '_self');
  };

  return (
    <div className={cls(styles.container, className)}>
      <p
        className="gray-color text-sm font-medium cursor-pointer"
        onClick={handleHomePage}
      >
        {fm('home')}
      </p>
      <ArrowchevronRightIcon className={cls('gray-color', styles.arrowIcon)} />
      <h5 className="text-sm font-medium">{subPageName}</h5>
    </div>
  );
};
